import React from "react";
import DefaultFriendPic from "site_media/images/default-profile-pic-feeds.png";
import DefaultGroupPic from "site_media/images/groups_default.png";
import * as CONSTANT from "constants/text";
import { Fragment } from "react";

function ProfilePic(props) {
    return (
        <Fragment>
            <img
                className={props.className || "profile_pic"}
                src={props.profilePic || (props.type === CONSTANT.GROUPS ? DefaultGroupPic : DefaultFriendPic)}
                alt="" />
        </Fragment>
    );

}

export default ProfilePic;
